import { gql } from "graphql-request";
export const OVERVIEW_GET_CATEGORY_BY_ID = gql`
    query overviewGetCategoryById($id: Int, $language: String!) {
        category(id: $id, isDeleted: false) {
            id
            name
            label
            isOneToOneConsent
            title
            overview
            subtitle
            description
            languages
            TCPAMessage
            slug
            isOneToOneConsent
            faqs(languageEq: $language, isDeleted: false) {
                id
                question
                answer
            }
            topics(isDeleted: false) {
                id
                url {
                    main {
                        url
                    }
                    isMain
                    url
                }
                title
            }
            url(isActive: true, isDeleted: false, languageEq: $language) {
                isMain
                main {
                    url
                }
                url
            }
            metatags {
                key
                value
            }
            translations {
                key
                value
                language
            }
            mainImage {
                path
                fullPath
            }
        }
    }
`;
